import React from 'react';
import styled from 'styled-components';
import theme from '../../styles/theme';
import { formatTextContent } from '../../services/funnelService';

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.screenPadding};
  padding-top: calc(${theme.spacing.screenPadding} + 24px);
  padding-bottom: calc(${theme.spacing.screenPadding} + 80px); /* Extra bottom padding for mobile accessibility */
  overflow-y: auto; /* Enable scrolling within the container */
  
  /* Mobile-specific improvements */
  @media (max-width: ${theme.breakpoints.tablet}) {
    padding-bottom: calc(${theme.spacing.screenPadding} + 100px); /* Even more bottom padding on mobile */
  }
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  /* Remove justify-content: center to prevent content from being pushed down */
  align-items: center;
  max-width: 100%;
  min-height: 0; /* Allow content to shrink */
`;

const TextContent = styled.div`
  font-family: ${theme.typography.bodyFont};
  font-size: ${theme.typography.sizes.body};
  color: ${theme.colors.text};
  line-height: ${theme.typography.lineHeights.normal};
  margin-bottom: ${theme.spacing.xl};
  text-align: center;
  
  /* Support for HTML tags */
  strong, b {
    font-weight: ${theme.typography.weights.semiBold};
    color: ${theme.colors.text};
  }
  
  em, i {
    font-style: italic;
  }
  
  p {
    margin-bottom: ${theme.spacing.md};
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const LogoLink = styled.a`
  display: block;
  transition: transform ${theme.animation.durations.fast} ${theme.animation.easings.easeOut};
  
  &:hover {
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

const LogoImage = styled.img`
  max-width: 300px;
  width: 100%;
  height: auto;
  display: block;
`;

const CompleteScreen = ({ data, userProgress = {} }) => {
  // Get formatted HTML content if available
  const htmlContent = formatTextContent(data.content?.text, userProgress);

  return (
    <Container>
      <Content>
        {htmlContent && (
          <TextContent dangerouslySetInnerHTML={{ __html: htmlContent }} />
        )}
        
        <LogoLink
          href="https://www.thrivewithdory.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LogoImage
            src="/images/logo.svg"
            alt="Thrive with Dory"
          />
        </LogoLink>
      </Content>
    </Container>
  );
};

export default CompleteScreen; 